
import React from 'react';
import { Instagram, MessageSquare, TwitchIcon, Twitter, Youtube } from 'lucide-react';
import { ContentType, GeneratedContent } from './types';

export const CONTENT_TYPES: ContentType[] = [
  {
    id: 'tiktok-caption',
    name: 'TikTok Caption',
    icon: <TwitchIcon className="h-5 w-5" />,
    platforms: ['tiktok'],
    description: 'Short, catchy captions for TikTok videos with trending hashtags'
  },
  {
    id: 'instagram-caption',
    name: 'Instagram Caption',
    icon: <Instagram className="h-5 w-5" />,
    platforms: ['instagram'],
    description: 'Engaging captions for Instagram posts with relevant hashtags'
  },
  {
    id: 'tweet-thread',
    name: 'Tweet Thread',
    icon: <Twitter className="h-5 w-5" />,
    platforms: ['twitter'],
    description: 'Structured tweet threads to announce releases or share stories'
  },
  {
    id: 'video-script',
    name: 'Video Script',
    icon: <Youtube className="h-5 w-5" />,
    platforms: ['youtube', 'tiktok', 'instagram'],
    description: 'Short video scripts for promotional content across platforms'
  },
  {
    id: 'promo-hook',
    name: 'Promo Hook',
    icon: <MessageSquare className="h-5 w-5" />,
    platforms: ['all'],
    description: 'Catchy one-liners to promote your music across all platforms'
  },
];

export const MOCK_GENERATED: GeneratedContent[] = [
  {
    id: '1',
    type: 'TikTok Caption',
    platform: 'tiktok',
    content: 'New track just dropped! This one took 3 months to create but was worth every minute 🎵 #newmusic #indieartist #musicproducer #fyp',
    engagement: 87
  },
  {
    id: '2',
    type: 'Instagram Caption',
    platform: 'instagram',
    content: '✨ Excited to finally share this song with you all! "Summer Nights" is out everywhere now - link in bio. This track was inspired by those magical summer evenings when anything feels possible.\n\nWhat summer memories does this song bring back for you? Comment below! 💭\n\n#NewMusic #SummerNights #IndieArtist #NewRelease #SpotifyPlaylist',
    engagement: 92
  },
  {
    id: '3',
    type: 'Tweet Thread',
    platform: 'twitter',
    content: "1/ BIG NEWS: My new single \"Echoes\" is out TODAY on all platforms! This track represents a new direction for my sound...\n\n2/ I wrote \"Echoes\" during a difficult time last year, and the process was incredibly healing. It's about finding your voice when you feel lost.\n\n3/ The amazing @producer_jane helped bring this vision to life with her incredible production skills. Wait until you hear that bridge!\n\n4/ Listen now: [link] and let me know what you think!",
    engagement: 78
  },
];
